"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useChatMessages = void 0;
const moment_timezone_1 = __importDefault(require("moment-timezone"));
const react_1 = require("react");
const react_redux_1 = require("react-redux");
const axios_1 = require("axios");
const application_host_1 = require("../common/application-host");
const user_1 = require("../store/selectors/user");
const messeges_1 = require("../slices/messeges");
const subscription_1 = require("../slices/subscription");
const user_2 = require("../slices/user");
const useAppQuota_1 = require("./useAppQuota");
const useAuth_1 = require("./useAuth");
const error_1 = require("../common/error");
;
const useChatMessages = () => {
    const dispatch = (0, react_redux_1.useDispatch)();
    const userId = (0, react_redux_1.useSelector)((state) => state.getUserOptions.appUser?.id || "");
    const conversation = (0, react_redux_1.useSelector)(user_1.selectConversation);
    const appUser = (0, react_redux_1.useSelector)((state) => state.getUserOptions.appUser);
    const accessToken = (0, react_redux_1.useSelector)(user_1.selectAccessToken);
    const { auth } = (0, useAuth_1.useAuth)();
    const onStreaming = (0, react_1.useCallback)((streamText) => {
        dispatch((0, user_2.setTextStreaming)(streamText));
    }, []);
    const { loadUserQuota } = (0, useAppQuota_1.useAppQuota)();
    // Force refresh conversations on screen refresh
    const refreshMessageQuota = (0, react_1.useCallback)(async () => {
        if (userId) {
            const quota = await loadUserQuota();
            if (quota) {
                dispatch((0, subscription_1.setUserQuota)(quota));
            }
        }
    }, [dispatch, userId]);
    const onStreamFinished = (0, react_1.useCallback)(async () => {
        dispatch((0, user_2.setCharacterIsTyping)(false));
    }, []);
    /**
     * OnClick of Send button
     * Send message to API
     */
    const sendMessageAsStream = (0, react_1.useCallback)(async (source, fileIds, onLoad, onFinish) => {
        const { message, files } = source;
        return new Promise(async (resolve, _reject) => {
            if (conversation) {
                const errorRef = { isError: false };
                const sendDate = new Date();
                dispatch((0, user_2.setCharacterIsTyping)(true));
                dispatch((0, user_2.insertNewMessage)({
                    conversationId: conversation.id,
                    createdAt: sendDate.toISOString(),
                    id: '',
                    isRead: false,
                    message: message ?? '',
                    sender: "user",
                    updatedAt: sendDate.toISOString(),
                    mediaUrls: [],
                    filesSource: files?.map(({ url, file: { name } }) => ({ url, name })),
                }));
                const xhr = new XMLHttpRequest();
                xhr.onreadystatechange = async () => {
                    if (xhr.readyState === 3 && xhr.status === 200) {
                        if (!errorRef.isError) {
                            try {
                                const responseObject = JSON.parse(xhr.responseText);
                                errorRef.isError = true;
                                resolve(new error_1.APIError(responseObject.error?.message, { reason: 'Out of Quota' }));
                            }
                            catch {
                                dispatch((0, user_2.setTextStreaming)(xhr.responseText));
                                onLoad?.(xhr.responseText);
                            }
                        }
                        ;
                    }
                    else if (xhr.readyState === 4) {
                        if (!errorRef.isError) {
                            if (xhr.status === axios_1.HttpStatusCode.Unauthorized) {
                                resolve(new error_1.RequestError(new axios_1.AxiosError(), { reason: 'Session Out' }));
                            }
                            else {
                                try {
                                    const responseObject = JSON.parse(xhr.responseText);
                                    errorRef.isError = true;
                                    resolve(new error_1.APIError(responseObject.error?.message, { reason: 'Out of Quota' }));
                                }
                                catch {
                                    await onFinish?.(xhr.responseText);
                                    resolve(xhr.responseText);
                                }
                            }
                            ;
                        }
                        dispatch((0, user_2.setCharacterIsTyping)(false));
                    }
                };
                xhr.open("POST", `${application_host_1.ADD_API}messages/send`);
                if (accessToken) {
                    xhr.setRequestHeader("Authorization", `Bearer ${accessToken}`);
                }
                else if (appUser?.id) {
                    xhr.setRequestHeader("user", appUser?.id);
                }
                xhr.setRequestHeader("User-Time-Zone", moment_timezone_1.default.tz.guess());
                const requestData = new FormData();
                requestData.append('payload', JSON.stringify({
                    message,
                    conversationId: conversation.id,
                    fileIds,
                    stream: true,
                }));
                files?.map(({ file }) => requestData.append('file', file));
                try {
                    xhr.send(requestData);
                }
                catch (error) {
                    console.log(error, xhr, xhr.getAllResponseHeaders());
                }
                ;
            }
            ;
        });
    }, [accessToken, appUser, conversation]);
    /**
     * Initial stream..
     * Send message to API
     */
    const sendEmptyMessageStream = (0, react_1.useCallback)(async (msgConversationId, newMessegeRequest) => {
        return new Promise(async (resolve, _reject) => {
            const xhr = new XMLHttpRequest();
            dispatch((0, user_2.setCharacterIsTyping)(true));
            xhr.onreadystatechange = async () => {
                if (xhr.readyState === 3 && xhr.status === 200) {
                    onStreaming(xhr.responseText);
                }
                else if (xhr.readyState === 4) {
                    const date = new Date();
                    const responseData = {
                        message: xhr.responseText,
                        conversationId: msgConversationId,
                        createdAt: date.toISOString(),
                        id: '',
                        isRead: false,
                        sender: "assistant",
                        updatedAt: date.toISOString(),
                        mediaUrls: [],
                    };
                    onStreamFinished();
                    resolve(responseData);
                }
            };
            xhr.open("POST", `${application_host_1.ADD_API}messages/send`);
            if (accessToken) {
                xhr.setRequestHeader("Authorization", `Bearer ${accessToken}`);
            }
            else if (appUser?.id) {
                xhr.setRequestHeader("user", appUser?.id);
            }
            xhr.setRequestHeader("User-Time-Zone", moment_timezone_1.default.tz.guess());
            const requestData = new FormData();
            requestData.append('payload', newMessegeRequest);
            xhr.send(requestData);
        });
    }, [onStreaming, onStreamFinished]);
    /**
     * Send message to API
     */
    const sendMessage = (0, react_1.useCallback)(async (messegeRequest) => {
        let response = await dispatch((0, messeges_1.sendMessegeAsync)(messegeRequest));
        console.log("sendMessegeAsync hook response:", response);
        if (response?.payload?.error) {
            console.log("Retry once hook sendMessege...", messegeRequest);
            response = await dispatch((0, messeges_1.sendMessegeAsync)(messegeRequest));
        }
        return response;
    }, [userId]);
    return {
        sendMessage,
        sendMessageAsStream,
        sendEmptyMessageStream,
        refreshMessageQuota,
    };
};
exports.useChatMessages = useChatMessages;
